/** Marks which report a saved file belongs to, inside the existing `name` field. */
export const REPORT_NAME_SEPARATOR = " :: ";
export const DAILY_REPORT_LABEL = "Daily report";

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function reportDateStamp(iso) {
  const date = iso ? new Date(`${String(iso).slice(0, 10)}T12:00:00`) : new Date();
  if (Number.isNaN(date.getTime())) return "Report";
  const month = date.toLocaleDateString("en-US", { month: "short" });
  return `${date.getDate()}${month}${date.getFullYear()}`;
}

export function reportLabelHead(reportLabel) {
  return `${String(reportLabel || "Report").trim() || "Report"}${REPORT_NAME_SEPARATOR}`;
}

/** Saved files for this report. Older daily reports have no label and stay on the daily report list. */
export function belongsToReport(name, reportLabel) {
  const text = String(name || "").trim();
  const label = String(reportLabel || "").trim();
  if (!text || !label) return false;
  if (text.startsWith(reportLabelHead(label))) return true;
  return label === DAILY_REPORT_LABEL && !text.includes(REPORT_NAME_SEPARATOR);
}

/** The part the user can edit. The report name in front of ` :: ` is not part of this. */
export function reportFilePart(name, reportLabel) {
  let text = String(name || "").trim();
  const head = reportLabelHead(reportLabel);
  while (text.startsWith(head)) text = text.slice(head.length).trim();
  return text.replace(/^(::\s*)+/, "").trim();
}

/** Every save keeps the report name at the front, even when the edited name no longer has it. */
export function ensureReportLabel(name, reportLabel) {
  const part = reportFilePart(name, reportLabel);
  if (!part) return "";
  return `${reportLabelHead(reportLabel)}${part}`;
}

export function fileNameForReport(reportLabel, iso, existingNames = []) {
  const stamp = reportDateStamp(iso);
  const head = reportLabelHead(reportLabel);
  const pattern = new RegExp(`^${escapeRegExp(stamp)}-(\\d+)$`);
  const used = new Set();
  existingNames.forEach((name) => {
    const text = String(name || "").trim();
    if (!belongsToReport(text, reportLabel)) return;
    const bare = text.startsWith(head) ? text.slice(head.length) : text;
    const match = pattern.exec(bare);
    if (match) used.add(Number(match[1]));
  });
  let sequence = 1;
  while (used.has(sequence)) sequence += 1;
  return `${head}${stamp}-${sequence}`;
}
